import { useDrawingBoard } from './useDrawingBoard';

export type DrawingBoardState = ReturnType<typeof useDrawingBoard>;

export default function DrawingGallery({ board }: { board: DrawingBoardState }) {
  const { drawings, setLightbox, handleDelete } = board;

  return (
    <>
      {drawings.length === 0 ? (
        <div className="text-center py-12">
          <div className="w-16 h-16 flex items-center justify-center bg-stone-100 rounded-full mx-auto mb-4">
            <i className="ri-pencil-line text-stone-400 text-2xl"></i>
          </div>
          <p className="text-stone-400 text-sm">Henüz çizim bulunmuyor</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {drawings.map((drawing) => (
            <div
              key={drawing.id}
              className="group relative bg-white rounded-xl border border-stone-200 overflow-hidden cursor-pointer"
              onClick={() => setLightbox({ svg: drawing.drawing_data, title: drawing.title || '' })}
            >
              <div className="w-full aspect-[4/3] overflow-hidden bg-white">
                <img
                  src={drawing.drawing_data}
                  alt={drawing.title || 'Çizim'}
                  className="w-full h-full object-contain"
                />
              </div>
              {drawing.title && (
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <p className="text-white text-xs font-medium truncate">{drawing.title}</p>
                </div>
              )}
              <button
                onClick={(e) => { e.stopPropagation(); handleDelete(drawing); }}
                className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center rounded-full bg-black/40 text-white hover:bg-red-500 transition-colors opacity-0 group-hover:opacity-100 cursor-pointer"
              >
                <i className="ri-delete-bin-line text-sm"></i>
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
